import Navbar from './Navbar'
import enhance from './Navbar.enhancer'

export default enhance(Navbar)
